<div class="custom-sidenav-panel">
  @let parameterSetsValue = parameterSets();
  @let resolutionsValue = resolutions();

  <h3 class="sidenav-header-title">
    <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
    {{ 'HOME.SETTINGS' | translate }}
  </h3>

  <div class="sidenav-layout-container">
    <h4 class="sidenav-section-title">
      {{ 'PRODUCT.EPP.SETTINGS.TABLE.CFG' | translate }}
    </h4>

    <p class="mat-body-small text-muted">
      {{ 'PRODUCT.EPP.SETTINGS.TABLE.DRAGNDROP' | translate }}
    </p>

    <mat-divider></mat-divider>

    <div class="sidenav-scroll-content">
      <mat-accordion class="sidenav-accordion">
        @for (
          resolution of resolutionsValue;
          track getResolutionKey(resolution)
        ) {
          <mat-expansion-panel
            [expanded]="
              selectedResolution()?.hourly === resolution.hourly &&
              selectedResolution()?.days === resolution.days
            ">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <fa-icon [icon]="['far', 'tasks']"></fa-icon> &nbsp;
                <strong>{{ resolution.days }}</strong>
                &nbsp;
                {{ 'PRODUCT.EPP.RESOLUTION.DAYS' | translate }}
                <small class="counter-badge">
                  &nbsp; ({{
                    'PRODUCT.EPP.RESOLUTION.HOURLY.' + resolution.hourly
                      | translate
                  }})
                </small>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @for (parameterset of parameterSetsValue; track parameterset) {
              @if (hasSettingsParameters(resolution, parameterset)) {
                <div class="parameter-set-group">
                  <h5 class="parameter-group-header">
                    <span>
                      {{
                        'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset
                          | translate
                      }}
                      <small class="counter-badge">
                        ({{
                          getSelectedParametersCountForResolutionAndSet(
                            resolution,
                            parameterset
                          )
                        }}/{{
                          getTotalParametersCountForResolutionAndSet(
                            resolution,
                            parameterset
                          )
                        }})
                      </small>
                    </span>

                    <mat-checkbox
                      class="select-all-checkbox"
                      [checked]="isAllSelected(resolution, parameterset)"
                      [indeterminate]="isSomeSelected(resolution, parameterset)"
                      (change)="
                        toggleSelectAll(
                          $event.checked,
                          resolution,
                          parameterset
                        )
                      ">
                      {{ 'PRODUCT.COMMON.SELECTALL' | translate }}
                    </mat-checkbox>
                  </h5>

                  @let settingsParametersValue =
                    getSettingsParameters(resolution, parameterset);

                  <mat-selection-list
                    class="sidenav-selection-list"
                    cdkDropList
                    [cdkDropListData]="settingsParametersValue"
                    (cdkDropListDropped)="
                      onDrop($event, resolution, parameterset)
                    "
                    (selectionChange)="
                      onParameterSelectionChange(
                        $event,
                        resolution,
                        parameterset
                      )
                    ">
                    @for (
                      entry of settingsParametersValue;
                      track entry.parameter
                    ) {
                      <mat-list-option
                        cdkDrag
                        checkboxPosition="after"
                        class="sidenav-list-item"
                        [value]="entry.parameter"
                        [selected]="entry.selected">
                        <span matListItemIcon class="list-item-icon-wrapper">
                          @if (isMobilePlatform()) {
                            <div cdkDragHandle class="drag-handle-zone">
                              <span
                                appWmIcon
                                [inputParameter]="entry.parameter"></span>
                            </div>
                          } @else {
                            <div class="static-icon-zone">
                              <span
                                appWmIcon
                                [inputParameter]="entry.parameter"></span>
                            </div>
                          }
                        </span>

                        <span matListItemLine class="list-item-text">
                          {{ 'METPARA_EPP.' + entry.parameter | translate }}
                        </span>

                        <mat-divider></mat-divider>
                      </mat-list-option>
                    }
                  </mat-selection-list>
                </div>
              }
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>

    <mat-divider></mat-divider>

    <div class="sidenav-footer-actions">
      <button
        mat-flat-button
        class="btn-restore"
        (click)="onRestoreStandardSettings()"
        [matTooltip]="'PRODUCT.EPP.SETTINGS.RESTORE' | translate">
        <fa-icon [icon]="['far', 'sync']"></fa-icon>
      </button>

      <button
        mat-flat-button
        color="warn"
        class="btn-cancel"
        (click)="onCancelSettings()">
        <fa-icon [icon]="['far', 'times']"></fa-icon>
        {{ 'PRODUCT.EPP.SETTINGS.CANCEL' | translate }}
      </button>

      <button
        mat-flat-button
        color="primary"
        class="btn-save"
        (click)="onSaveSettings()">
        <fa-icon [icon]="['far', 'check']"></fa-icon>
        {{ 'PRODUCT.EPP.SETTINGS.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
